import { render } from "./HorizontalStepper.vue?vue&type=template&id=0064cbb0&scoped=true"
import script from "./HorizontalStepper.vue?vue&type=script&lang=js"
export * from "./HorizontalStepper.vue?vue&type=script&lang=js"

import "./HorizontalStepper.vue?vue&type=style&index=0&id=0064cbb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0064cbb0"]])

export default __exports__